import { combineReducers } from 'redux';
import * as actions from '../actions';
import { HERRAMIENTA_LAPIZ, HERRAMIENTA_ELIMINAR_DIBUJO } from '../constantes';

function herramienta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HERRAMIENTA_LAPIZ;
  var action = arguments[1];

  switch (action.type) {
    case actions.SELECCIONAR_HERRAMIENTA:
      return action.herramienta;

    default:
      return state;
  }
}

function colorLapiz() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000000';
  var action = arguments[1];

  switch (action.type) {
    case actions.SELECCIONAR_COLOR_LAPIZ:
      return action.valor;

    default:
      return state;
  }
}

function colorMarcador() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#00ff00';
  var action = arguments[1];

  switch (action.type) {
    case actions.SELECCIONAR_COLOR_MARCADOR:
      return action.valor;

    default:
      return state;
  }
}

function grosorLapiz() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var action = arguments[1];

  switch (action.type) {
    case actions.SELECCIONAR_GROSOR_LAPIZ:
      return action.valor;

    default:
      return state;
  }
}

function grosorMarcador() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
  var action = arguments[1];

  switch (action.type) {
    case actions.SELECCIONAR_GROSOR_MARCADOR:
      return action.valor;

    default:
      return state;
  }
}

function alphaMarcador() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.4;
  var action = arguments[1];

  switch (action.type) {
    case actions.SELECCIONAR_ALPHA_MARCADOR:
      return action.valor;

    default:
      return state;
  }
}

function grosorBorrador() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  var action = arguments[1];

  switch (action.type) {
    case actions.SELECCIONAR_GROSOR_BORRADOR:
      return action.valor;

    default:
      return state;
  }
}

function editorActivo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case actions.ACTIVAR_EDITOR:
      return true;

    case actions.DESACTIVAR_EDITOR:
      return false;

    default:
      return state;
  }
}

function dataURL() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case actions.CARGAR_IMAGEN:
      return action.dataURL;
    // case actions.ACTIVAR_EDITOR:
    //     return action.dataURL || null

    case actions.SELECCIONAR_HERRAMIENTA:
      if (action.herramienta === HERRAMIENTA_ELIMINAR_DIBUJO) {
        return null;
      }

      return state;

    case actions.NOTIFICAR_CAMBIOS:
      return action.dataURL;

    default:
      return state;
  }
}

var pizarra = combineReducers({
  editorActivo: editorActivo,
  herramienta: herramienta,
  colorLapiz: colorLapiz,
  grosorLapiz: grosorLapiz,
  colorMarcador: colorMarcador,
  grosorMarcador: grosorMarcador,
  alphaMarcador: alphaMarcador,
  grosorBorrador: grosorBorrador,
  dataURL: dataURL
});
export default pizarra;